/* Review spotlight rotation. */
(function () {
  'use strict';

  const H = window.Hystride;
  if (!H) return;

  H.register('review-spotlight', {
    mount(root) {
      const items = Array.from(root.querySelectorAll('[data-vo-item]'));
      const indexEl = root.querySelector('[data-vo-index]');
      const steps = Array.from(root.querySelectorAll('[data-vo-step]'));
      if (items.length < 2) return null;

      const speed = parseInt(root.dataset.speed, 10) || 7000;
      const wants = root.dataset.autorotate === 'true';
      let i = 0;
      let timer = null;

      const paint = (n) => {
        i = (n + items.length) % items.length;
        items.forEach((el, k) => {
          const on = k === i;
          el.classList.toggle('on', on);
          // Hide the inactive quotes from assistive tech as well as visually —
          // they are all in the DOM at once so the block cannot change height.
          el.toggleAttribute('aria-hidden', !on);
          // .vo-q span starts opacity:0 and only .in reveals it (CSS-driven
          // fade-in). Liquid sets .in on the server-rendered first quote only —
          // without this, every quote reached by rotating past it stayed
          // invisible forever, since nothing else ever added the class.
          if (on) {
            const span = el.querySelector('.vo-q span');
            if (span) span.classList.add('in');
          }
        });
        if (indexEl) indexEl.textContent = String(i + 1);
      };

      const stop = () => {
        clearInterval(timer);
        timer = null;
      };

      const start = () => {
        stop();
        if (!wants || H.reduceMotion()) return;
        timer = setInterval(() => paint(i + 1), speed);
      };

      // The prototype never touches its interval from the buttons, so clicking
      // at 6.9s advances again 100ms later. Restarting the clock is the fix.
      const onStep = (e) => {
        paint(i + parseInt(e.currentTarget.dataset.voStep, 10));
        start();
      };

      steps.forEach((b) => b.addEventListener('click', onStep));
      paint(0);
      start();

      return { stop, steps, onStep };
    },

    unmount(root, s) {
      if (!s) return;
      s.stop();
      s.steps.forEach((b) => b.removeEventListener('click', s.onStep));
    },
  });
})();
